<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import { useApiClient } from "@/api/client";
import router from "@/router/router";

const isLoading = ref(true);
const count = ref(0);

onBeforeMount(() => fetchRecentStoredDocuments());

const fetchRecentStoredDocuments = async () => {
	isLoading.value = true;
	const response = await useApiClient("alerts").getActiveAlertsInAlert();
	if (response.isOk()) {
		count.value = response.value;
	}
	isLoading.value = false;
};
</script>

<template>
	<v-card v-if="!isLoading" min-height="70" @click="router.push('/alerts')">
		<div class="d-flex align-center pa-4 pr-6 ga-4">
			<v-chip
				class="count"
				size="large"
				:variant="count ? 'tonal' : 'flat'"
				:color="count ? 'error' : ''"
			>
				{{ count > 99 ? "99+" : count }}
			</v-chip>
			<span>Active alert{{ count === 1 ? "" : "s" }}</span>
			<v-spacer />
			<v-icon icon="fa: fal fa-arrow-right" />
		</div>
	</v-card>
</template>

<style scoped lang="scss">
.count {
	font-size: 28px;
	font-weight: 500;
}
</style>
